import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "gamestrade_admin_token";
export const getAuthToken = () => localStorage.getItem(TOKEN_KEY);
export const setAuthToken = (t) => {
  if (t) localStorage.setItem(TOKEN_KEY, t);
  else localStorage.removeItem(TOKEN_KEY);
};

export const api = axios.create({
  baseURL: API,
});

api.interceptors.request.use((config) => {
  const t = getAuthToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const PLATFORM_LABELS = {
  "ps5": "PS5",
  "ps4": "PS4",
  "switch 1": "Switch 1",
  "switch 2": "Switch 2",
  "xbox": "Xbox",
  "pc": "PC",
  "multi": "Multi-Platform",
  // legacy values that may exist in DB
  "playstation": "PlayStation",
  "nintendo": "Nintendo",
};

export const platformLabel = (v) => PLATFORM_LABELS[v] || (v ? v.charAt(0).toUpperCase() + v.slice(1) : "");
